import React from "react";
import { useState, useEffect } from "react";
import Navbar from "../Components/Navbar";
import img from "../Assets/basd.png";
import testimonials from "../Assets/test.png";
import b1 from "../Assets/b1 (2).png";
import b2 from "../Assets/b1 (1).png";
// import visual from "../Assets/image121.png";
// import visual2 from "../Assets/image-1.png";
import Reform from "../Assets/Link.png";
import { motion } from "framer-motion";
// import img2 from "../Assets/Group 1171274914.png";
// import img3 from "../Assets/image.png";
import arrow from "../Assets/Link2.png";
import icon from "../Assets/Group 1171274915.png";
import Footer from "../Components/Footer";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { Link } from "react-router-dom";
// import banner1 from "../Assets/banner.png";
// import banner2 from "../Assets/51508.jpg";
// import banner3 from "../Assets/44671.jpg";
import Slider from "../Components/Slider";

const testimonialsData = [
  {
    image: "image1.jpg",
    title: "Fantastic",
    text: "Lorem ipsum dolor sit amet consectetur. Lacus et tempus nulla scelerisque turpis commodo commodo nulla. Diam massa sed ornare sed ullamcorper sit condimentum convallis. Lobortis massa leo aliquam felis eu ullamcorper faucibus dictum suscipit.",
    author: "Kendra Rose"
  },
  {
    image: "image2.jpg",
    title: "Amazing Service",
    text: "Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Vestibulum tortor quam, feugiat vitae.",
    author: "John Doe"
  },
  {
    image: "image3.jpg",
    title: "Highly Recommend",
    text: "Suspendisse potenti. Nullam quis risus eget urna mollis ornare vel eu leo. Cras mattis consectetur purus sit amet fermentum.",
    author: "Emily Smith"
  }
];

function Home() {
  const [modal, setmodal] = useState(false);
  const [modal2, setmodal2] = useState(false);
  const [modal3, setmodal3] = useState(false);
  const [modal4, setmodal4] = useState(false);
  const [modal5, setmodal5] = useState(false);
  const [index, setIndex] = useState(0);
  const [direction, setDirection] = useState(1);

  const nextTestimonial = () => {
    setDirection(1);
    setIndex((prevIndex) => (prevIndex + 1) % testimonialsData.length);
  };

  const prevTestimonial = () => {
    setDirection(-1);
    setIndex(
      (prevIndex) =>
        (prevIndex - 1 + testimonialsData.length) % testimonialsData.length
    );
  };
  // const images = [banner1, banner2, banner3];

  // const [currentImage, setCurrentImage] = useState(0);

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     setCurrentImage((prev) => (prev + 1) % images.length);
  //   }, 5000);

  //   return () => clearInterval(interval);
  // }, []);
  return (
    <>
      <Navbar />
      <Slider/>
      {/* <div
        className="banner"
        style={{ backgroundImage: `url(${images[currentImage]})` }}
      >
        <div className="banner-overlay">
          <p>EXPLORE THE BENEFITS OF HOT YOGA</p>
          <br />

          <h3>
            Transform Your Mind and
            <br /> Body with Daily Yoga
          </h3>
          <br />
          <Link to='/bookclasses'>

          <button>Book A Class</button>
          </Link>
        </div>
      </div> */}
      <div className="SERVICES-home">
        {/* <p>SERVICES</p> */}
        {/* <h3>Discover Personalized Yoga Classes For Your Unique Needs</h3> */}
        <h3>Discover Our Services</h3>
        <br />
       <div className="SERVICES-home">
         {/* <div className="service-cards">
       <div className="service-cards-wrapper">
         <div className="service-page auto-scroll">
           
           {Array(2)
             .fill(0)
             .map((_, i) => (
               <React.Fragment key={i}>
                 <div className="service-card-div">
                   <div className="service-card-border">
                     <Link to="/service1">
                       <div className="service-card service-card1"></div>
                     </Link>
                   </div>
                   <h4>Pilates</h4>
                 </div>
                 <div className="service-card-div">
                   <div className="service-card-border">
                     <Link to="/service2">
                       <div className="service-card service-card2"></div>
                     </Link>
                   </div>
                   <h4>Yoga</h4>
                 </div>
                 <div className="service-card-div">
                   <div className="service-card-border">
                     <Link to="/service3">
                       <div className="service-card service-card3"></div>
                     </Link>
                   </div>
                   <h4>Workshops</h4>
                 </div>
                 <div className="service-card-div">
                   <div className="service-card-border">
                     <Link to="/service4">
                       <div className="service-card service-card4"></div>
                     </Link>
                   </div>
                   <h4>The Restore Suite</h4>
                 </div>
                 <div className="service-card-div">
                   <div className="service-card-border">
                     <Link to="/service5">
                       <div className="service-card service-card5"></div>
                     </Link>
                   </div>
                   <h4>Special Events & Experiences</h4>
                 </div>
               </React.Fragment>
             ))}
         </div>
       </div>
     </div> */}
          <div className="service-cards">
       
                 <div className="service-card-div">
                   <div className="service-card-border">
                     <Link to="/service1">
                       <div className="service-card service-card1"></div>
                     </Link>
                   </div>
                   <h4>Pilates</h4>
                 </div>
                 <div className="service-card-div">
                   <div className="service-card-border">
                     <Link to="/service2">
                       <div className="service-card service-card2"></div>
                     </Link>
                   </div>
                   <h4>Yoga</h4>
                 </div>
                 <div className="service-card-div">
                   <div className="service-card-border">
                     <Link to="/service3">
                       <div className="service-card service-card3"></div>
                     </Link>
                   </div>
                   <h4>Workshops</h4>
                 </div>
                 <div className="service-card-div">
                   <div className="service-card-border">
                     <Link to="/service4">
                       <div className="service-card service-card4"></div>
                     </Link>
                   </div>
                   <h4>The Restore Suite</h4>
                 </div>
                 <div className="service-card-div">
                   <div className="service-card-border">
                     <Link to="/service5">
                       <div className="service-card service-card5"></div>
                     </Link>
                   </div>
                   <h4>Special Events & Experiences</h4>
                 </div>
             
         </div>
         </div>
  </div>


     
      {/* <div className='visual'>

  <div className='visual-left'>
  <p>Visual journey of mind and body harmony</p>
  
  <img src={visual}/>


  </div>
  <div className='visual-right'>
  <img className='visual2' src={visual2}/>

  <h3>Book Our classes</h3>
  
  <div className='Our-classes'>
<h4>Platis</h4>
<img src={Reform}/>
  </div>

 
  <div className='Our-classes'>
<h4>Yoga</h4>
<img src={Reform}/>
  </div>
  
  <div className='Our-classes'>
<h4>Workshop</h4>
<img src={Reform}/>
  </div>

<button>View All Classes</button>
  </div>

  </div> */}
      {/* <div className="mq-div">
  <div className="marquee">
    <p>From Stress to Serenity</p>
    <p>From Stress to Serenity</p>
    <p>From Stress to Serenity</p>
    <p>From Stress to Serenity</p>
  </div>
</div>
<div className='howyoga'>
<div className='howyoga-left'>
  <img src={img}/>
  </div>
  <div className='howyoga-right'>
  <h3>How Yoga Can Help You Achieve Mental Clarity</h3>
  <p>Yoga is more than just movement—it’s a reset for your mind. Through breathwork, mindful poses, and meditation, yoga helps clear mental fog, reduce stress, and improve focus. It creates a sense of inner calm, allowing you to process thoughts with clarity and navigate life with a peaceful, centered mindset.</p>
  <br/>
  <br/>
  <h4>Strong Foundations Yoga</h4>
  <p>A strong practice begins with a solid foundation. This class is your gateway to strength, balance, and confidence, focusing on alignment, breathwork, and mindful movement. Whether you're new to yoga or refining your flow, you’ll build stability from the ground up—one breath, one pose, one powerful step forward.</p>
  <br/>
  <br/>
    <div className='bt-div'>
      <div className='bt'>
      <img src={icon}/>
        <p>Root deep.  </p>
      </div>
      <div className='bt'>
      <img src={icon}/>
        <p>Rise strong.</p>
      </div>
      <div className='bt'>
      <img src={icon}/>
        <p>Flow freely.</p>
      </div>
    </div>

</div>
</div> */}
      {/* <div className='testimonials'>
      <h3>Testimonials</h3>
      <div className='testimonials-div'>
        <div className='testimonials-div-left'>
          <motion.img 
            key={index} 
            src={testimonialsData[index].image} 
            alt='testimonial' 
            initial={{ opacity: 0, x: direction * 100 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: -direction * 100 }}
            transition={{ duration: 0.5 }}
          />
          <img src={testimonials}/>
        </div>
        <motion.div 
          className='testimonials-div-right'
          key={index}
          initial={{ opacity: 0, x: direction * 100 }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: -direction * 100 }}
          transition={{ duration: 0.5 }}
        >
       <div>
       <h4>{testimonialsData[index].title}</h4>
          <br />
          <p>{testimonialsData[index].text}</p>
          <br />
          <h5>{testimonialsData[index].author}</h5>
       </div>
          <div className='buttons'>
            <button onClick={prevTestimonial}><img src={b1}/></button>
            <button onClick={nextTestimonial}><img src={b2}/></button>
          </div>
        </motion.div>
      </div>
    </div> */}
      {/* <div className="CONTACTUS-div">
        <div className="CONTACTUS-div-left">
          <img src={img2} />
        </div>
        <div className="CONTACTUS-div-center">
          <p>CONTACT US</p>

          <h3>
            Your journey to wellness starts with a single step—reaching out
          </h3>
          <div className="home-cont-info">
          <div className="home-cont-info-icon">
          <i class="bi bi-telephone-fill"></i>
</div>
   <p> +971 58 588 7738</p>

          </div>
          <div className="home-cont-info">
          <div className="home-cont-info-icon">
          <i class="bi bi-envelope-fill"></i>
</div>
     <p>info@aluradubai.com </p>

          </div>
          <div className="home-cont-info">
          <div className="home-cont-info-icon">
          <i class="bi bi-geo-alt-fill"></i>

</div>
    <p>Villa No. 01-- Khalfan Mohammed Bin Lahej Al Hajri - Bur Dubai - Al Quoz 1</p>


          </div>
          <h4>
            Whether you’re looking for guidance, have questions, or are ready to
            begin your practice, we’re here to support you. Our team is
            dedicated to helping you find balance, healing, and transformation
            in a space designed for your well-being. "Let’s connect and create a
            path to a healthier, more mindful you together.
          </h4>
          <Link to="/contact">
            <button>Contact Us</button>
          </Link>
        </div>
        <div className="CONTACTUS-div-right">
          <img src={img3} />
        </div>
      </div> */}
      <Modal size="md" isOpen={modal} toggle={() => setmodal(!modal)}>
        <ModalBody>
          <div className="service-modal">
            <h2>Move, Heal & Transform </h2>
            <p>
              At Alura, we offer thoughtfully designed yoga classes to help you
              strengthen your body, calm your mind, and restore balance. Each
              class is crafted to meet different needs, whether you're looking
              for energy, flexibility, or deep healing.
            </p>
            <button>Book Classes</button>
          </div>
        </ModalBody>
      </Modal>
      <Modal size="lg" isOpen={modal2} toggle={() => setmodal2(!modal2)}>
        <ModalBody>
          <div className="service-modal">
            <h2>Dynamic Vinyasa – Flow Freely, Move Powerfully </h2>
            <p>
              This is for the movers, the breath-followers, and the
              energy-seekers. Dynamic Vinyasa is all about seamless movement,
              strength-building, and finding rhythm in every flow. Expect
              creative sequences, playful transitions, and a practice that
              challenges your body while freeing your mind. By the end, you’ll
              feel strong, empowered, and completely alive.
            </p>
            <ul>
              <li>Perfect if you love fast, energizing flows</li>
              <li>Builds endurance, flexibility & focus</li>
              <li>A great way to relieve stress & feel refreshed</li>
            </ul>
            <button>Book Classes</button>
          </div>
        </ModalBody>
      </Modal>
      <Modal size="lg" isOpen={modal3} toggle={() => setmodal3(!modal3)}>
        <ModalBody>
          <div className="service-modal">
            <h2>Building Balance – Find Your Center, Strengthen Within </h2>
            <p>
              Balance isn’t just about standing still—it’s about finding
              stability in movement and life. This class focuses on core
              strength, alignment, and control, helping you feel more grounded,
              steady, and connected. Whether you’re working on physical balance
              or seeking a sense of inner calm, this practice teaches you to
              move with confidence and grace.
            </p>
            <ul>
              <li>Ideal for improving focus, posture & coordination </li>
              <li>Strengthens your core & stabilizing muscles</li>
              <li>Helps bring a sense of calm & clarity</li>
            </ul>
            <button>Book Classes</button>
          </div>
        </ModalBody>
      </Modal>
      <Modal size="lg" isOpen={modal4} toggle={() => setmodal4(!modal4)}>
        <ModalBody>
          <div className="service-modal">
            <h2>Deep Stretch – Release, Relax & Let Go</h2>
            <p>
              Sometimes, we just need to slow down. Deep Stretch is all about
              releasing tension, opening up the body, and sinking into
              stillness. With long-held postures and mindful breathing, you’ll
              feel your stress melt away while your muscles relax and lengthen.
              This is your time to pause, breathe, and give your body the love
              it deserves.
            </p>
            <ul>
              <li> Perfect for easing tightness & improving flexibility</li>
              <li> Helps with recovery & relaxation</li>
              <li> A gentle way to restore both body & mind</li>
            </ul>
            <button>Book Classes</button>
          </div>
        </ModalBody>
      </Modal>
      <Modal size="lg" isOpen={modal5} toggle={() => setmodal5(!modal5)}>
        <ModalBody>
          <div className="service-modal">
            <h2>Healing Yoga – A Safe Space to Heal & Reconnect</h2>
            <p>
              Healing Yoga is more than a class—it’s a space to breathe, feel,
              and restore from within. Whether you’re experiencing stress,
              emotional fatigue, or just need a moment to yourself, this
              practice gently guides you toward peace, presence, and self-care.
              Through slow movement, breathwork, and deep relaxation, you’ll
              leave feeling lighter, calmer, and more connected to yourself.
            </p>
            <ul>
              <li> Ideal for stress relief & emotional healing</li>
              <li> Soothes the nervous system & promotes inner balance</li>
              <li> Helps create a sense of deep peace & renewal</li>
            </ul>
            <button>Book Classes</button>
          </div>
        </ModalBody>
      </Modal>
      {/* <div className="map">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d462560.68281993904!2d54.897823313520995!3d25.076280448422047!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f43496ad9c645%3A0xbde66e5084295162!2sDubai%20-%20United%20Arab%20Emirates!5e0!3m2!1sen!2sin!4v1741756611755!5m2!1sen!2sin"
          allowfullscreen=""
          loading="lazy"
          referrerpolicy="no-referrer-when-downgrade"
        ></iframe>
      </div> */}
      <div className="contact-home">
        <div className="contact-home-left">
          <h3>Contact Us</h3>
          <p>We’d love to hear from you</p>
          <br />
          <br />
          <div className="home-loc">
            <div>
              <div className="home-cont-info-icon">
                <i class="bi bi-telephone-fill"></i>
              </div>
            </div>
            <div>
              <h4>Call </h4>
              <p> +971 58 588 7738</p>
            </div>
          </div>
          <br />
          <br />

          <div className="home-loc">
            <div>
              <div className="home-cont-info-icon">
                <i class="bi bi-envelope-fill"></i>
              </div>
            </div>
            <div>
              <h4>Email </h4>
              <p>info@aluradubai.com </p>
            </div>
          </div>
          <br />
          <br />
          <div className="home-loc">
            <div>
              <div className="home-cont-info-icon">
                <i class="bi bi-geo-alt-fill"></i>
              </div>
            </div>
            <div>
              <h4>Address </h4>
              <p>
                Al Quoz 1, 17 Al Meydan Street, Villa 1, Behind KML Building -
                Dubai
              </p>
            </div>
          </div>
        </div>
        <div className="contact-home-right">
        {/* <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3610.920052638644!2d55.260477099999996!3d25.1721772!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f6951a5946393%3A0x94d10e67dd96bb9d!2sAlura!5e0!3m2!1sen!2sin!4v1745406399653!5m2!1sen!2sin" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe> */}
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3610.920052638644!2d55.260477099999996!3d25.1721772!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f6951a5946393%3A0x94d10e67dd96bb9d!2sAlura!5e0!3m2!1sen!2sin!4v1745406399653!5m2!1sen!2sin"
            allowfullscreen=""
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default Home;
